import {Component, OnDestroy, OnInit} from '@angular/core';
import {DialogRef} from '@app/components/dialog/dialog-ref';

@Component({
  selector: 'navaar-dialog-score',
  templateUrl: './dialog-phone-number-support.component.html',
  styleUrls: ['./dialog-phone-number-support.component.scss']
})
export class DialogPhoneNumberSupportScoreComponent {
  constructor(
    public readonly dialog: DialogRef) {
  }

  public onCloseModal() {
    this.dialog.close();
  }
}
